import { FlatList, Pressable, Text } from '@rbilabs/universal-components';
import { rgba } from 'polished';

import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';

export const List = FlatList.withConfig({
  backgroundColor: rgba(Styles.color.black, 0.04),
  paddingY: '$3',
});

export const PressableTime = Pressable.withConfig<{ $isSelected: boolean; enableCartV2: boolean }>(
  p => ({
    minWidth: '$32',
    marginX: '$2',
    background: p.$isSelected
      ? p.enableCartV2
        ? primitive.bk.$bbqBrown
        : Styles.color.primary
      : theme.token('pickup-timed-fire-selector-button-background'),
    borderRadius: Styles.borderRadius,
    paddingY: '$3',
    paddingX: '$4',
    _pressed: {
      background: Styles.shadowColor,
    },
    _disabled: {
      background: Styles.color.grey.two,
    },
    _web: {
      cursor: 'pointer',
    },
  })
);

export const TimeText = Text.withConfig<{ $isSelected: boolean }>(p => ({
  textAlign: 'center',
  color: p.$isSelected ? Styles.color.white : Styles.color.black,
}));
